var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-line__wrapper",attrs:{"data-start-divider":"","data-end-divider":"","data-section-item":""}},[_c('div',{staticClass:"c-line",class:_vm.lineClassesComputed})])
}
var staticRenderFns = []

export { render, staticRenderFns }